import { delay } from 'redux-saga'
import {
  select,
  fork,
  put,
  all,
  call,
  take,
  takeLatest,
  takeEvery,
  cancelled,
} from 'redux-saga/effects'

import {
  UPDATE_ORIGINAL_REVISION,
  UPDATE_MODIFIED_REVISION,
} from './constants'

import {
  LOAD_REVISION_DATA_SUCCESS,
  FETCH_REVISION_DATA_ERROR,
} from 'containers/Project/Revision/constants'

import {
  updateOriginalRevision,
  updateModifiedRevision,
  loadRevisionData,
} from 'containers/Project/Revision/actions'

function* handleOriginalRevision({ projectId, revisionId }) {
  yield put(loadRevisionData(projectId, revisionId))
  const action = yield take([LOAD_REVISION_DATA_SUCCESS, FETCH_REVISION_DATA_ERROR])
  if (action.type === LOAD_REVISION_DATA_SUCCESS)
    yield put(updateOriginalRevision(revisionId))
}

function* handleModifiedRevision({ projectId, revisionId }) {
  yield put(loadRevisionData(projectId, revisionId))
  const action = yield take([LOAD_REVISION_DATA_SUCCESS, FETCH_REVISION_DATA_ERROR])
  if (action.type === LOAD_REVISION_DATA_SUCCESS)
    yield put(updateModifiedRevision(revisionId))
}

function* watchUpdateOriginalRevision() {
  yield takeEvery(UPDATE_ORIGINAL_REVISION, handleOriginalRevision)
}

function* watchUpdateModifiedRevision() {
  yield takeEvery(UPDATE_MODIFIED_REVISION, handleModifiedRevision)
}

function* loadSagas() {
  yield all([
    fork(watchUpdateModifiedRevision),
    fork(watchUpdateOriginalRevision),
  ])
}

export default loadSagas
